<template>
  <div>
    <div class="my-container" style="position: relative;">
      <h2>Dataset details</h2>
      <el-image :src="icon_path" v-on:click="showOrHide"
                style="position: absolute;width: 40px;height:40px;right: 10px;top:5px;z-index: 9999"/>
      <div v-show="showDatasetDetails" style="margin: 1px">
        <el-table
            :data="datasetDetails"
            :header-cell-style="{margin: '0',padding: '0', color: 'black'}"
            :cell-style="{margin: '0',padding: '0', color: 'black'}"
            stripe
            border>
          <el-table-column
              prop="title"
              label="title"
              min-width="30px">
          </el-table-column>
          <el-table-column
              prop="content"
              label="content">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="my-container">
      <h2>Spatially variable(SV) genes</h2>
      <h3 style="text-align: left;margin-left: 10px">* SV genes identified by SpatialDE(Q-value	&lt;0.05)</h3>
      <div style="margin: 1px">
        <el-table
            stripe
            :data="SpatialDE.slice((currentPage1-1)*pageSize1,currentPage1*pageSize1)"
            :row-style="{height: '10px'}"
            :cell-style="{padding: '0', color: 'black', margin: '0'}"
            :header-cell-style="{padding: '0', margin: '0', fontSize: '10px', color: 'black'}">
          <el-table-column
              label="ID"
              type="index"
              width="80">
            <template scope="scope">
              <span>{{(currentPage1 - 1) * pageSize1 + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gene" label="GENE" width="130" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="SAMPLE" width="120" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="type" label="Type" :formatter="caseTypeNamesFormat" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="p" label="P_VALUE" sortable :formatter="rounding" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="q" label="Q_VALUE" sortable :formatter="rounding" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination align='center' @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                     :current-page="currentPage1"
                     :page-sizes="[1,5,10,20]"
                     :page-size="pageSize1"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="SpatialDE.length">
      </el-pagination>
      <h3 style="text-align: left;margin-left: 10px">* SV genes identified by trendsceek(Q-value	&lt;0.05)</h3>
      <div style="margin: 1px">
        <el-table
            stripe
            :data="TrendSceek.slice((currentPage2-1)*pageSize2,currentPage2*pageSize2)"
            :row-style="{height: '10px'}"
            :cell-style="{padding: '0', color: 'black', margin: '0'}"
            :header-cell-style="{padding: '0', margin: '0', fontSize: '10px', color: 'black'}">
          <el-table-column
              label="ID"
              type="index"
              width="80">
            <template scope="scope">
              <span>{{(currentPage2 - 1) * pageSize2 + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gene" label="GENE" width="130" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="SAMPLE" width="120" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="type" label="Type" :formatter="caseTypeNamesFormat" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="qval_emark" label="Q-VALUE(Emark)" sortable :formatter="rounding2" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="qval_vmark" label="Q-VALUE(Vmark)" sortable :formatter="rounding2" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="qval_corr" label="Q-VALUE(MarkCorr)" sortable :formatter="rounding2" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="qval_markvario" label="Q-VALUE(MarkVario)" sortable :formatter="rounding2" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination align='center' @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
                     :current-page="currentPage2"
                     :page-sizes="[1,5,10,20]"
                     :page-size="pageSize2"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="TrendSceek.length">
      </el-pagination>
    </div>

    <div class="my-container">
      <h2>SV genes expression</h2>
      <div id="content">
        <div id="left" class="my-div-center">
          <el-form ref="form" :model="formData" label-width="80px" size="small" style="width: 80%;float: right">
            <el-form-item>
              <span slot="label">
                <span style="color: black">Type:</span>
              </span>
              <el-select v-model="formData.Type"
                         placeholder="please select"
                         clearable
                         filterable
                         default-first-option
                         @change="getSample">
                <el-option
                    v-for="item in typelist"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Sample">
              <span slot="label">
                <span style="color: black">Sample:</span>
              </span>
              <el-select v-model="formData.Array"
                         placeholder="please select"
                         clearable
                         allow-create
                         filterable
                         @change="getGene">
                <el-option
                    v-for="item in array_list"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Gene">
              <span slot="label">
                <span style="color: black">Gene:</span>
              </span>
              <el-select v-model="formData.Gene"
                         clearable
                         filterable
                         placeholder="please select">
                <el-option
                    v-for="item in genelist"
                    :key="item.gene"
                    :label="item.gene"
                    :value="item.gene">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Size">
              <span slot="label">
                <span style="color: black">Size:</span>
              </span>
              <el-input v-model="formData.Size" placeholder="please choose size(1.0-2.2)" />
            </el-form-item>

            <el-form-item label="Img-alpha">
              <span slot="label">
                <span style="color: black">Img-alpha:</span>
              </span>
              <el-input v-model="formData.Img_alpha" placeholder="please choose alpha(0-1)"/>
            </el-form-item>

            <el-form-item label="Plot-alpha">
              <span slot="label">
                <span style="color: black">Plot-alpha:</span>
              </span>
              <el-input v-model="formData.Plot_alpha" placeholder="please choose alpha(0-1)"/>
            </el-form-item>


            <el-form-item>
              <el-button @click="onSubmit">submit</el-button>
              <template v-if=" imgPath !== '' ">
                <el-button @click="download">download</el-button>
              </template>
            </el-form-item>
          </el-form>

        </div>
        <div id="right" class="my-div-center">
          <div  style="width: 600px;height: 600px;">
            <div v-bind:class="echartsClassType">
              <!--              使用echarts绘图-->
              <div id="main" style="height: 600px;width: 600px" ></div>
            </div>
            <div v-bind:class="rClassType" >
              <el-image :src="imgPath" fit="contain">
                <div slot="placeholder" class="image-slot">
                  <i class="el-icon-loading"></i>loading
                </div>
                <div slot="error" class="image-slot" style="font-size: 300px;color: gray">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>

          <!--          <img :src=imgPath alt="no pic here" width="100%">-->

        </div>
      </div>
    </div>

    <div class="my-container">
      <h2>Gene enrichment analysis</h2>
      <h3 style="text-align: left;margin-left: 10px">* Functional enrichment analysis of SV genes</h3>
      <div id="tab1">
        <el-tabs
            stretch
            ref="tabs1"
            v-model="activeName1"
            type="card"
            @tab-click="handleClick"
            style="margin-top: 10px;color: black" >
          <el-tab-pane label="GO enrichment analysis(SpatialDE)" v-if="img_exist.spgo" name="first1">
            <div v-for="(item,index) in img.spgoimg" :key="index" id="sp_go">
              <div v-show="item.path !== ''">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <img :src=item.path width="80%" alt="pic load error">
              </div>
            </div>
            <!--          <img :src=imgPath[0] style="width: 80%" alt=""/>-->
          </el-tab-pane>
          <el-tab-pane label="KEGG enrichment analysis(SpatialDE)" v-if="img_exist.spkegg" name="second1">
            <div v-for="(item,index) in img.spkeggimg" :key="index" id="sp_kegg">
              <div v-show="CheckImgExists(item.path)">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <img :src=item.path width="80%"  alt="pic load error">
              </div>
            </div>
            <!--          <img :src=imgPath[2] style="width: 80%" alt=""/>-->
          </el-tab-pane>
          <el-tab-pane label="GO enrichment analysis(trendsceek)" v-if="img_exist.trendsceekgo" name="third1">
            <div v-for="(item,index) in img.trendsceekgoimg" :key="index" id="trendsceek_go">
              <div v-show="CheckImgExists(item.path)">
                <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                <img :src=item.path width="80%"  alt="pic load error">
              </div>
            </div>
            <!--          <img :src=imgPath[4] style="width: 80%" alt=""/>-->
          </el-tab-pane>
          <el-tab-pane label="KEGG enrichment analysis(trendsceek)" v-if="img_exist.trendsceekkegg" name="forth1">
            <div v-for="(item,index) in img.trendsceekkeggimg" :key="index" id="trendsceek_kegg">
              <div v-show="CheckImgExists(item.path)">
                <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                <img :src=item.path width="80%"  alt="pic load error">
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div style="text-align: center">Hint: SV genens identified by SpatialDE and trendsceek((Q-value	&lt;0.05))</div>
      <br/>
      <h3 style="text-align: left;margin-left: 10px">* Pathway enrichment analysis of SV genes</h3>
      <div id="tab2">
        <el-tabs
            ref="tabs2"
            v-model="activeName2"
            type="card"
            @tab-click="handleClick"
            stretch
            style="margin-top: 10px;color: black">
          <el-tab-pane label="GO enrichment analysis(SpatialDE)" v-if="img_exist.spgopath" name="first2">
            <div v-for="(item,index) in img.spgopathimg" :key="index" id="sp_go_path">
              <div v-show=" item.path !== '' ">
                <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                <img :src=item.path width="60%"  alt="pic load error">
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="KEGG enrichment analysis(SpatialDE)" v-if="img_exist.spkeggpath" name="second2">
            <div v-for="(item,index) in img.spkeggpathimg" :key="index" id="sp_kegg_path">
              <div v-show="CheckImgExists(item.path)">
                <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                <img :src=item.path width="60%"  alt="pic load error">
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="GO enrichment analysis(trendsceek)" v-if="img_exist.trendsceekgopath" name="third2">
            <div v-for="(item,index) in img.trendsceekgopathimg" :key="index" id="trendsceek_go_path">
              <div v-show="CheckImgExists(item.path)">
                <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                <img :src=item.path width="60%"  alt="pic load error">
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="KEGG enrichment analysis(trendsceek)" v-if="img_exist.trendsceekkeggpath" name="forth2">
            <div v-for="(item,index) in img.trendsceekkeggpathimg" :key="index"  id="trendsceek_kegg_path">
              <div v-show="CheckImgExists(item.path)">
                <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                <img :src=item.path width="60%"  alt="pic load error">
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div style="text-align: center">Hint: SV genens identified by SpatialDE and trendsceek((Q-value	&lt;0.05))</div>
      <br/>
    </div>
  </div>

</template>

<script>
import * as echarts from "echarts/core";
import Vue from "vue";
import axios from '../../util/axiosConfig'
Vue.prototype.$axios = axios

export default {
  name: "Details",
  data() {
    return {
      datasetDetails: [],
      showDatasetDetails: false,
      icon_path: require('../../assets/show.png'),
      // datasetDetail_tip: 'hide',
      SpatialDE: [],
      currentPage1: 1, // 当前页码
      total1: 100, // 总条数
      pageSize1: 10, // 每页的数据条数
      TrendSceek: [],
      currentPage2: 1, // 当前页码
      total2: 100, // 总条数
      pageSize2: 10, // 每页的数据条数
      activeName1: 'first1',
      activeName2: 'first2',
      img:{
        spgoimg: [],
        spkeggimg: [],
        trendsceekgoimg: [],
        trendsceekkeggimg: [],
        spgopathimg: [],
        spkeggpathimg: [],
        trendsceekgopathimg: [],
        trendsceekkeggpathimg: [],
      },
      img_exist: {
        spgo: true,
        spkegg: true,
        trendsceekgo: true,
        trendsceekkegg: true,
        spgopath: true,
        spkeggpath: true,
        trendsceekgopath: true,
        trendsceekkeggpath: true,
      },
      typelist: ['SpatialDE','Trendsceek'],
      sample_list: [],
      array_list: [],
      genelist: [],
      SVG:{
        path: '',
        data: []
      },
      formData: {
        datasetID: '',
        Array:  '',
        Type: '',
        Gene: '',
        Size: '1.0',
        Img_alpha: '0.5',
        Plot_alpha: '0.5'
      },
      imgPath: require("@/assets/sample.png"),
      isSVG: true,
      echartsClassType: 'class_hide',
      rClassType: 'class_show',
      isFirst: true,
    };
  },
  // watch: {
  //   isShow() {
  //     this.$nextTick(() => {
  //       this.$refs.tabs1.resize();
  //       this.$refs.tabs2.resize();
  //     });
  //   },
  // },
  created() {
    let _this = this
    _this.$nextTick(function () {
      _this.getDatasetInformation();
      _this.getSVGPic();
      _this.getSpatialDEPic();
      _this.getTrendSceek();
    })
  },
  mounted() {
    this.initEcharts();
    // this.getMarkerArray();
  },
  methods: {
    getDatasetInformation() {
      let _this = this
      console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/dataset/'+ _this.$route.params.id)
          .then(function (response){
            console.log('dataset:')
            console.log(response)
            _this.datasetDetails = response.data.details
          })
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/SVG/'+ _this.$route.params.id)
          .then(function (response){
            console.log('samples:')
            console.log(response)
            _this.sample_list = response.data
          })
    },
    showOrHide() {
      console.log("before:"+this.showDatasetDetails)
      if (this.showDatasetDetails === false){
        this.showDatasetDetails = true
        this.icon_path = require('../../assets/hide.png')
        // this.datasetDetail_tip = 'hide'
      }else {
        this.showDatasetDetails = false
        this.icon_path = require('../../assets/show.png')
        // this.datasetDetail_tip = 'show'
      }
      console.log("after:"+this.showDatasetDetails)
    },
    getSVGPic() {
      let _this = this
      console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/SVG/img/'+ _this.$route.params.id)
          .then(function (response){
            console.log('img:')
            let resdata=JSON.parse(JSON.stringify(response.data));
            console.log(resdata)
            _this.img = resdata
            _this.img_exist.spgo = _this.img.spgoimg.length
            _this.img_exist.spkegg = _this.img.spkeggimg.length
            _this.img_exist.trendsceekgo = _this.img.trendsceekgoimg.length
            _this.img_exist.trendsceekkegg = _this.img.trendsceekkeggimg.length
            _this.img_exist.spgopath = _this.img.spgopathimg.length
            _this.img_exist.spkeggpath = _this.img.spkeggpathimg.length
            _this.img_exist.trendsceekgopath = _this.img.trendsceekgopathimg.length
            _this.img_exist.trendsceekkeggpath = _this.img.trendsceekkeggpathimg.length
            console.log('img_exist:')
            console.log(_this.img_exist)
            // _this.sp_go_img = resdata.spgoimg
            // _this.sp_kegg_img = resdata.spkeggimg
            // _this.trendsceek_go_img = resdata.trendsceekgoimg
            // _this.trendsceek_kegg_img = resdata.trendsceekkeggimg
            // _this.sp_go_path_img = resdata.spgopathimg
            // _this.sp_kegg_path_img = response.data.spkeggpathimg
            // _this.trendsceek_go_path_img = response.data.trendsceekgopathimg
            // _this.trendsceek_kegg_path_img = response.data.trendsceekkeggpathimg
          })
    },
    getSpatialDEPic() {
      let _this = this
      console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/SVG/spatialDE/'+ _this.$route.params.id)
          .then(function (response){
            console.log('spatialDE:')
            console.log(response)
            _this.SpatialDE = response.data.SpatialDE
            // _this.formData.datasetID = _this.$route.params.id
            // _this.formData.Type = 'SpatialDE'
            // _this.formData.Array = _this.SpatialDE[0].name
            // _this.formData.Gene = _this.SpatialDE[0].gene
            // _this.formData.Size = 1.0
            // _this.formData.Img_alpha = 0.5
            // _this.formData.Plot_alpha = 0.5
            // console.log("formData")
            // console.log(_this.formData)
            // _this.onSubmit()
            // _this.getGene()
          })
    },
    getTrendSceek() {
      let _this = this
      console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/SVG/trendsceek/'+ _this.$route.params.id)
          .then(function (response){
            console.log('Trendsceek:')
            console.log(response)
            _this.TrendSceek = response.data.Trendsceek
          })
    },
    getSample(){
      let _this = this
      _this.array_list = _this.sample_list
    },

    isEcharts(){
      let _this = this
      //判断是不是Vue图像
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/isSVG/'+ _this.$route.params.id + '/' + _this.formData.Array)
          .then(function (response){
            _this.isSVG = response.data.isSVG
            console.log("isVue: "+ response.data.isSVG)
            _this.SVG.path = response.data.path
            _this.isSVG = true
            if (_this.isSVG === true){
              _this.echartsClassType = 'class_show'
              _this.rClassType = 'class_hide'
            }else {
              _this.echartsClassType = 'class_hide'
              _this.rClassType = 'class_show'
            }
          })
    },
    getMarkerArray(){
      let _this = this
      console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/'+ _this.$route.params.id)
          .then(function (response){
            _this.name = response.data.name
            // console.log('array:'+ _this.name)
            _this.formData.Array = _this.name[0]
            _this.formData.Gene = ''
            _this.getGene()
          })
    },
    getGene(){
      let _this = this
      //SVG
      // _this.clearSVG()
      _this.isSVG = ''
      // _this.SVG.height = 600
      _this.formData.Gene = ''
      _this.genelist = []
      _this.SVG.data.length = 0
      // console.log("Changed Array:"+_this.formData.Array)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/'+ _this.$route.params.id + '/' + _this.formData.Array)
          .then(function (response){
            _this.genelist = response.data.topgene
            // console.log("genelist get!")
            _this.formData.Gene = _this.genelist[0].gene
            console.log(_this.genelist)
            // console.log(_this.formData)
            _this.isEcharts()
            // setTimeout(function (){
            //   _this.onSubmit()
            // },2000)
          })
    },
    onSubmit(){
      let _this = this
      _this.formData.datasetID = _this.$route.params.id
      console.log("Array:"+_this.formData.Array)
      if (_this.isSVG === true){
        Vue.prototype.$message.info("drawing picture, please wait...")
        console.log("request SVG data")
        //pic
        // _this.$axios.get(
        //     'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/gene/echarts/'
        //     + _this.$route.params.id + '/' + _this.formData.Array + '/' + _this.formData.Gene)
        //     .then(function (response){
        //       console.log("gene_expression:")
        //       console.log(response.data)
        //       _this.SVG.data = response.data.data
        //       _this.changeSummit()
        //     })
        //echarts
        _this.$axios.get(
            'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/gene/echarts/'
            + _this.$route.params.id + '/' + _this.formData.Array + '/' + _this.formData.Gene)
            .then(function (response){
              console.log("gene_expression:")
              console.log(response.data)
              _this.SVG.data = response.data.data
              if(response.status === 200){
                Vue.prototype.$message.success("success!")
              }
              _this.changeSummit()
            }).catch(function (e) {
              console.log(e)
              Vue.prototype.$message.error("Something is wrong...")
        })

        //SVG写法
        // _this.$axios.get(
        //     'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/gene/'
        //     + _this.$route.params.id + '/' + _this.formData.Array + '/' + _this.formData.Gene)
        //     .then(function (response){
        //       console.log("gene_expression:")
        //       console.log(response.data)
        //       _this.SVG.data = response.data.data
        //       _this.changeSummit()
        //     })
      }
      else if(_this.isSVG === false){
        Vue.prototype.$message.info("drawing picture, please wait...")
        console.log("request R data")
        _this.$axios.post(
            'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/run',
            _this.formData)
            .then(function (response){
              console.log("pic:")
              console.log(response.data)
              _this.imgPath = response.data
              if (response.data === 'error'){
                Vue.prototype.$message.error("Something is wrong...")
              }else {
                Vue.prototype.$message.success("success!")
              }
            })
            .catch(function (){
              Vue.prototype.$message.error("Something is wrong...")
            })
      }else {
        console.log("wait isSVG init")
      }
    },
    download(){
      if (this.isSVG === true){

        //svg下载
        // var mysvg = document.getElementById("mySVG");
        // let width = this.SVG.width
        // let height = this.SVG.height
        // console.log(width)
        // this.covertSVG2Image(mysvg,"img",width,height)
      }else {
        //创建一个a标签
        const a_b = document.createElement('a');
        //设置href指向
        a_b.href = this.imgPath;
        //设置图片下载名字
        // a_b.download = name;
        //点击a标签
        a_b.click()
      }

    },
    initEcharts(){
      const chartDom = document.getElementById('main');
      const myChart = echarts.init(chartDom);
      let option;

      const schema = [
        { name: 'x', index: 0, text: 'x' },
        { name: 'y', index: 1, text: 'y' },
        { name: 'gene', index: 2, text: 'gene' },
        { name: 'expression', index: 3, text: 'expression' },
      ];
      // const itemStyle = {
      //   emphasis: {
      //     focus : 'self'
      //   }
      // };
      option = {
        color: ['#ff0000'],
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
              title: "save",
              name: "marker.png",
            },
          },
        },
        grid: {
          right: '15%',
        },
        visualMap: [
          {
            left: 'right',
            bottom: '40%',
            dimension: 3,
            type: 'continuous',
            calculable:true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime:true,                          //拖拽时，是否实时更新
            precision:2,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 10,
            itemHeight: 120,
            align:"auto",
            text: ['expression'],
            textGap: 20,
            inRange: {
              color: ['blue','yellow', 'red']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                color: ['blue','yellow', 'red']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + schema[2].text + '：' + value[2]
                + '</div>'
                + schema[0].text + '：' + value[0] + '<br>'
                + schema[1].text + '：' + value[1] + '<br>'
                + schema[3].text + '：' + value[3] + '<br>';
          }
        },
        xAxis: {},
        yAxis: {},
        series: [
          {
            symbolSize: 10,
            data: [
              [1, 1,'a',20],
              [8.07, 6.95],
              [13.0, 7.58],
              [9.05, 8.81],
              [11.0, 8.33],
              [14.0, 7.66],
              [13.4, 6.81],
              [10.0, 6.33],
              [14.0, 8.96],
              [12.5, 6.82],
              [9.15, 7.2],
              [11.5, 7.2],
              [3.03, 4.23],
              [12.2, 7.83],
              [2.02, 4.47],
              [1.05, 3.33],
              [4.05, 4.96],
              [6.03, 7.24],
              [12.0, 6.26],
              [12.0, 8.84],
              [7.08, 5.82],
              [5.02, 5.68]
            ],
            type: 'scatter'
          }
        ]
      };
      option && myChart.setOption(option);

    },
    changeSummit() {
      let _this = this
      const myChart = echarts.getInstanceByDom(document.getElementById('main'));
      // if (chartDom == null) { // 如果不存在，就进行初始化。
      //   chartDom = echarts.init(document.getElementById(id));
      // }
      // const myChart = echarts.init(chartDom);
      let option;
      myChart.setOption({
        series: [
          {
            symbolSize: 10,
            data: _this.SVG.data,
            type: 'scatter'
          }
        ]
      })
      // chartDom.setAttribute('_echarts_instance_', '')
      option && myChart.setOption(option,true);
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange1(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage1 = 1;
      this.pageSize1 = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange1(val) {
      console.log(`当前页: ${val}`);
      this.currentPage1 = val;
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange2(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage2 = 1;
      this.pageSize2 = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange2(val) {
      console.log(`当前页: ${val}`);
      this.currentPage2 = val;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    caseTypeNamesFormat (row) {
      let showProp = null
      // console.log(this.datasetDetails[5].content)
      row.caseTypeNames ? showProp = row.caseTypeNames : showProp = this.datasetDetails[1].content
      return showProp
    },
    rounding(row,column) {
      return parseFloat(row[column.property]).toFixed(19)
    },
    rounding2(row,column) {
      return parseFloat(row[column.property]).toFixed(10)
    },
    CheckImgExists(imgurl) {
      var ImgObj = new Image(); //判断图片是否存在
      ImgObj.src = imgurl;
      //存在图片
      if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
        return true;
      } else {
        return false;
      }
    },

  }
}
</script>

<style scoped>
#content{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
#left{
  margin-top: 10px;
  width: 400px;
}
#left .el-form-item .el-select {
  width: 100%;
}
#right{
  width: 60%;
  float: left;
  /*max-width: 400px;*/
  /*max-height: 400px;*/
}
/*.my-form-item{*/
/*  display: flex;*/
/*  flex-direction: row-reverse;*/
/*  justify-content: flex-start;*/
/*  padding: 0;*/
/*  margin: 0;*/
/*   !*background-color: #42b983;*!*/
/* }*/
.el-image{
  cursor:pointer;
}

.class_show{
  display: block;
}
.class_hide{
  display: none;
}
#tab1 /deep/ .el-tabs__item.is-active{
  color:#3F78C1 !important;
  font-weight: bold;
}
#tab1 /deep/ .el-tabs__item:hover {
  /*background-color: #00BFFF;*/
  background-color: #3F78C1;
  color: #FFFFFF !important;
  /*font-size: 25px;*/
  /*border-bottom: none;*/
}
#tab2 /deep/ .el-tabs__item.is-active{
  color:#3F78C1 !important;
  font-weight: bold;
}
#tab2 /deep/ .el-tabs__item:hover {
  /*background-color: #00BFFF;*/
  background-color: #3F78C1;
  color: #FFFFFF !important;
  /*font-size: 25px;*/
  /*border-bottom: none;*/
}
</style>
